export const convertSmartChars = function (value) {
    if (!value) return value

    const charMap = {
        "\u2013": "-",
        "\u2014": "-",
        "\u2015": "-",
        "\u2017": "_",
        "\u2018": "'",
        "\u2019": "'",
        "\u201a": ",",
        "\u201b": "'",
        "\u201c": '"',
        "\u201d": '"',
        "\u201e": '"',
        "\u201f": '"',
        "\u2026": "...",
        "\u2032": "'",
        "\u2033": '"',
        "\u00bc": "1/4",
        "\u00bd": "1/2",
        "\u00be": "3/4",
        "\u2150": "1/7",
        "\u2151": "1/9",
        "\u2152": "1/10",
        "\u2153": "1/3",
        "\u2154": "2/3",
        "\u2155": "1/5",
        "\u2156": "2/5",
        "\u2157": "3/5",
        "\u2158": "4/5",
        "\u2159": "1/6",
        "\u215a": "5/6",
        "\u215b": "1/8",
        "\u215c": "3/8",
        "\u215d": "5/8",
        "\u215e": "7/8",
        "\u2189": "0/3",
    }
    const re = 
        /[\u2013\u2014\u2015\u2017\u2018\u2019\u201a\u201b\u201c\u201d\u201e\u201f\u2026\u2032\u2033\u00bc\u00bd\u00be\u2150-\u215e\u2189]/g
    return value.replace(re, ch => charMap[ch] ?? ch)
}
